import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface FoodOptionsProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const FoodOptions: React.FC<FoodOptionsProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { food_options: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { food_options: data.additional_info?.food_options || null },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select food options..." },
    { value: "full_menu", label: "Full Menu" },
    { value: "snacks", label: "Snacks" },
    { value: "no_food", label: "No Food" },
  ]

  const fieldData = {
    field: "additional_info.food_options",
    name: "foodOptions",
    label: "Food Options",
    placeholder: "Select food options",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}

